import React from 'react';
import {translate} from 'react-i18next';
import moment from 'moment';
import CardSelector from './CardSelector';
import TagChooser from './TagChooser';

class FilterSidebar extends React.PureComponent {

    constructor(props) {

        super(props);

        this.handleCardChange = this.handleCardChange.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleTagRemove = this.handleTagRemove.bind(this);
        this.handleTagsAdd = this.handleTagsAdd.bind(this);
    }

    addTags(...tags) {

        if (this.props.onFilterChange) {

            const current = [...this.props.filters.tags];

            tags.forEach(tag => {

                if (!current.includes(tag))
                    current.push(tag);
            });

            if (current.length !== this.props.filters.tags.length)
                this.props.onFilterChange({tags: current});
        }
    }

    getFromUtc() {

        return this.props.filters.fromUtc.clone().local().format('YYYY-MM-DD');
    }

    getTagCards() {

        const {t} = this.props;
        const tags = this.props.filters.tags;

        return [

            {value: 'cherry', text: t('filterSidebar.tags.cherry'), selected: tags.includes('cherry'), image: require('./images/tags/cherry-not-selected.svg'), imageSelected: require('./images/tags/cherry-not-selected.svg')},
            {value: 'lime', text: t('filterSidebar.tags.lime'), selected: tags.includes('lime'), image: require('./images/tags/lime-not-selected.svg'), imageSelected: require('./images/tags/lime-not-selected.svg')},
            {value: 'hazel', text: t('filterSidebar.tags.hazel'), selected: tags.includes('hazel'), image: require('./images/tags/hazel-not-selected.svg'), imageSelected: require('./images/tags/hazel-not-selected.svg')},
            {value: 'oak', text: t('filterSidebar.tags.oak'), selected: tags.includes('oak'), image: require('./images/tags/oak-not-selected.svg'), imageSelected: require('./images/tags/oak-not-selected.svg')},
            {value: 'birch', text: t('filterSidebar.tags.birch'), selected: tags.includes('birch'), image: require('./images/tags/birch-not-selected.svg'), imageSelected: require('./images/tags/birch-not-selected.svg')},
            {value: 'beech', text: t('filterSidebar.tags.beech'), selected: tags.includes('beech'), image: require('./images/tags/beech-not-selected.svg'), imageSelected: require('./images/tags/beech-not-selected.svg')},
        ];
    }

    getToUtc() {
        return this.props.filters.toUtc.clone().add(-1, 'days').local().format('YYYY-MM-DD');
    }

    handleCardChange(e) {

        e.selected ? this.addTags(e.value) : this.removeTag(e.value);
    }

    handleInputChange(e) {
        const target = e.target;
        const name = target.name;
        let value = target.type === 'checkbox' ? target.checked : target.value;

        if (name === 'fromUtc')
            value = value ? moment.utc(value) : moment.utc().add(-1, 'months').hours(0).minutes(0).seconds(0).milliseconds(0);

        if (name === 'toUtc')
            value = value ? moment.utc(value).add(1, 'days') : moment.utc().add(1, 'days').hours(0).minutes(0).seconds(0).milliseconds(0);


        if (this.props.onFilterChange)
            this.props.onFilterChange({[name]: value});
    }

    handleTimePresetChange(timePreset) {

        this.props.onFilterChange({timePreset});
        
    }

    handleTagRemove(tag) {

        this.removeTag(tag);
    }

    handleTagsAdd(tags) {

        this.addTags(...tags);
    }

    removeTag(tag) {

        if (this.props.onFilterChange) {

            const tags = this.props.filters.tags;

            if (tags.includes(tag))
                this.props.onFilterChange({tags: tags.filter(x => x !== tag)});
        }
    }

    render() {

        const {t, filters: f} = this.props;

        return (

            <div className={`filter-sidebar m-3 rounded border shadow bg-white ${this.props.show ? 'show' : ''}`}>

                <div className="border-bottom p-3">
                   <span className="title">{t('filterSidebar.period')}</span>
                   <div className="input-group">
                       <div className="input-group-selector">
                          <button className={`smaller form-control ${this.props.filters.timePreset === "day" ? 'text-green' : ''}`} 
                            name="day" 
                            onClick={(e) => {this.handleTimePresetChange(e.target.name)}}>
                                {t('filterSidebar.DaySelector')}
                            </button>

                          <button className={`smaller form-control ${this.props.filters.timePreset === "week" ? 'text-green' : ''}`} 
                            name="week" 
                            onClick={(e) => {this.handleTimePresetChange(e.target.name)}}>
                                {t('filterSidebar.WeekSelector')}
                            </button>

                          <button className={`smaller form-control ${this.props.filters.timePreset === "month" ? 'text-green' : ''}`} 
                            name="month" 
                            onClick={(e) => {this.handleTimePresetChange(e.target.name)}}>
                                {t('filterSidebar.MonthSelector')}
                            </button>

                          <button className={`smaller form-control ${this.props.filters.timePreset === "customDate" ? 'text-green' : ''}`} 
                            name="customDate" 
                            onClick={(e) => {this.handleTimePresetChange(e.target.name)}}>
                                {t('filterSidebar.custom')}
                            </button>
                       </div> 
                    </div>
                    <div className="input-group-1">
                      <div className={`small form-control ${this.props.filters.timePreset !== "customDate" ? 'disabled' : ''}`}>
                        <span>
                          {t('filterSidebar.fromUtc')}
                          <input type="date" name="fromUtc" disabled={this.props.filters.timePreset !== "customDate"} value={this.getFromUtc()} onChange={this.handleInputChange} />
                        </span>
                      </div>
                      
                      <div className={`small form-control ${this.props.filters.timePreset !== "customDate" ? 'disabled' : ''}`}>  
                        <span>
                          {t('filterSidebar.toUtc')} 
                          <input type="date" name="toUtc" disabled={this.props.filters.timePreset !== "customDate"} value={this.getToUtc()} onChange={this.handleInputChange} />
                        </span>
                      </div>
                      
                    </div>
                </div>

                <div className="border-bottom p-3">
                    <div className="custom-control custom-checkbox">
                        <input id="filter-sidebar-multiple-photos-only" type="checkbox" name="multiplePhotosOnly" className="custom-control-input" checked={f.multiplePhotosOnly} onChange={this.handleInputChange}/>
                        <label htmlFor="filter-sidebar-multiple-photos-only" className="custom-control-label">{t('filterSidebar.multiplePhotosOnly')}</label>
                    </div>
                    <div className="custom-control custom-checkbox mt-2">
                        <input id="filter-sidebar-highlighted-only" type="checkbox" name="highlightedOnly" className="custom-control-input" checked={f.highlightedOnly} onChange={this.handleInputChange}/>
                        <label htmlFor="filter-sidebar-highlighted-only" className="custom-control-label">{t('filterSidebar.highlightedOnly')}</label>
                    </div>
                </div>

                <div className="border-bottom p-3">
                    <span className="title">{t('filterSidebar.searchTags')}</span>
                    <CardSelector cards={this.getTagCards()} onCardChange={this.handleCardChange}/>
                </div>

                <div className="p-3">
                    <TagChooser tags={f.tags} onTagsAdd={this.handleTagsAdd} onTagRemove={this.handleTagRemove}/>
                </div>

            </div>
        );
    }
}

export default translate()(FilterSidebar);



// WEBPACK FOOTER //
// ./src/components/FilterSidebar.js